import React from 'react';
import { InputFields } from './components/InputFields';
import style from './EditForm.module.scss';

export const EditForm: React.FC = () => (
	<div className={style.container} data-test="EditForm">
		<InputFields />
	</div>
);
